<template>
  <div class="Home">
    <div style="height: 100px"></div>
    <div class="content-wrapper">
      <!-- 标签内容 -->
      <div id="TeamsTab" class="tab-content">
        <img src="../../resources/images/Teams/68.png" alt="Teams">
        <img src="../../resources/images/Teams/69.png" alt="Teams">
        <img src="../../resources/images/Teams/70.png" alt="Teams">
        <img src="../../resources/images/Teams/71.png" alt="Teams">
        <img src="../../resources/images/Teams/72.png" alt="Teams">
        <img src="../../resources/images/Teams/73.png" alt="Teams">
        <div class="TryTeams">
            <div class="one">
                <img src="../../resources/images/Teams/76.png" alt="">
            </div>
            <div class="two">
                <div>
                    <h4>不如亲自体验一下？</h4>
                    <a href="https://forms.office.com/r/YnTgek17Ks" target="_blank"><img src="../../resources/images/Teams/申请试用.png" alt="Teams"></a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "solution",
  components: {},
  methods: {
  },
  mounted: function () {
  }
};
</script>

<style scoped>
    .TryTeams{
        width: 100%;
        height: 900px;
        text-align: center;
        display: flex;
    }
    .TryTeams h4{
        font-size: 35px;
        color: rgb(0, 0, 0);
    }
    .TryTeams img{
        width: 350px;
        height: 250px;
    }
    .TryTeams .one{
        width: 70%;
        height: 100%;
    }
    .one img{
        width: 100%;
        height: 100%;
    }
    .TryTeams .two{
        width: 30%;
        margin: auto;
    }
</style>


// WEBPACK FOOTER //
// src/pages/home/Teams.vue